import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithHttpStatus } from '../services/baseQuery';

// Define a service using a base URL and expected endpoints
export const promptStore = createApi({
    reducerPath: 'promptStore',
    baseQuery: baseQueryWithHttpStatus,
    endpoints: (builder) => ({
        getPromptRoleTitles: builder.mutation({
            query: (body) => {
                return {
                    url: '/gptbluePrompt/getPromptRoleTitles/',
                    method: 'POST',
                    body: { ...body },
                }
            },
        }),
        getPromptManualInstanceVariable: builder.mutation({
            query: (body) => {
                return {
                    url: '/gptbluePrompt/getPromptManualInstanceVariable/',
                    method: 'POST',
                    body: { ...body },
                }
            },
        })
    }),
})

export const {
    useGetPromptRoleTitlesMutation,
    useGetPromptManualInstanceVariableMutation,
} = promptStore;